export default __webpack_public_path__ + "static/media/Care06.eb166290.png";